export const RefundMethods = {
  CREDIT: "credit",
  CARD: "card"
};
